import React from "react";
import { UserRound, Search, Package, BellRing } from "lucide-react";
import "./coach-landing.css";
import { trackCoachCtaClick } from "../../analytics/googleAnalytics";

export default function CoachLandingDiscovery() {
  const coaches = [
    {
      image: "/assets/img/memoji/7294811.webp",
      name: "Valentina R.",
      specialty: "Entrenamiento funcional",
      workouts: 12,
      guides: 3,
      gradientClass: "avatar-gradient-1",
      position: "coach-1"
    },
    {
      image: "/assets/img/memoji/7309681.webp",
      name: "Marcos M.",
      specialty: "Nutrición deportiva",
      workouts: 8,
      guides: 2,
      gradientClass: "avatar-gradient-2",
      position: "coach-2"
    },
    {
      image: "/assets/img/memoji/8806247.webp",
      name: "Elsa S.",
      specialty: "Doctora",
      workouts: 20,
      guides: 5,
      gradientClass: "avatar-gradient-3",
      position: "coach-3"
    },
    {
      image: "/assets/img/memoji/9439767.webp",
      name: "Laura G.",
      specialty: "Yoga y mindfulness",
      workouts: 15,
      guides: 1,
      gradientClass: "avatar-gradient-4",
      position: "coach-4"
    },
    {
      image: "/assets/img/memoji/9439833.webp",
      name: "Marco T.",
      specialty: "HIIT y crossfit",
      workouts: 18,
      guides: 4,
      gradientClass: "avatar-gradient-5",
      position: "coach-5"
    },
    {
      image: "/assets/img/memoji/9440461.webp",
      name: "Javier F.",
      specialty: "Pilates y movilidad",
      workouts: 10,
      guides: 2,
      gradientClass: "avatar-gradient-6",
      position: "coach-6"
    },
    {
      image: "/assets/img/memoji/10491846.webp",
      name: "Daniela R.",
      specialty: "Running y resistencia",
      workouts: 6,
      guides: 3,
      gradientClass: "avatar-gradient-7",
      position: "coach-7"
    },
    {
      image: "/assets/img/memoji/androgynous-avatar-non-binary-queer-person.webp",
      name: "Carmen L.",
      specialty: "Nutrición vegana",
      workouts: 25,
      guides: 3,
      gradientClass: "avatar-gradient-8",
      position: "coach-8"
    }
  ];

  return (
    <section className="discovery-section">
      {/* Background effects */}
      <div className="discovery-bg">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>
      <div className="discovery-grid-pattern"></div>

      <div className="discovery-content">
        {/* LEFT - Text */}
        <div className="discovery-text">
          <div className="discovery-tag">Nuevo en Wayo</div>
          <h2>
            Una<br />
            <span className="text-gradient">red social fitness</span>
          </h2>
          <div className="headline-sub">donde también te pueden encontrar.</div>
          <p>
            Además de llevar a tus clientes, tienes un perfil público dentro de la app. Los usuarios de Wayo exploran perfiles de entrenadores, ven tu contenido y te pueden escribir. Tu perfil es tu escaparate; tu contenido, tu carta de presentación.
          </p>

          <div className="discovery-features">
            <div className="discovery-feature">
              <div className="discovery-feature-icon">
                <UserRound size={20} strokeWidth={2} aria-hidden="true" />
              </div>
              <span>Tu perfil profesional dentro de la app</span>
            </div>
            <div className="discovery-feature">
              <div className="discovery-feature-icon">
                <Search size={20} strokeWidth={2} aria-hidden="true" />
              </div>
              <span>Los usuarios te descubren por especialidad</span>
            </div>
            <div className="discovery-feature">
              <div className="discovery-feature-icon">
                <Package size={20} strokeWidth={2} aria-hidden="true" />
              </div>
              <span>Ven tus entrenos, guías, ebooks y recetas</span>
            </div>
            <div className="discovery-feature">
              <div className="discovery-feature-icon">
                <BellRing size={20} strokeWidth={2} aria-hidden="true" />
              </div>
              <span>Te pueden escribir desde la propia app</span>
            </div>
          </div>

          <a
            href="/coach/register"
            className="discovery-cta"
            onClick={() => trackCoachCtaClick("coach_landing_discovery")}
          >
            Quiero mi perfil de coach →
          </a>
        </div>

        {/* RIGHT - Visual constellation */}
        <div className="discovery-visual">
          {/* Orbit rings */}
          <div className="orbit-ring orbit-ring-1"></div>
          <div className="orbit-ring orbit-ring-2"></div>
          <div className="orbit-ring orbit-ring-3"></div>

          {/* Particles */}
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
          <div className="particle particle-5"></div>

          {/* Connection lines */}
          <div className="discovery-lines">
            <svg viewBox="0 0 600 600" fill="none">
              <line className="connection-line" x1="300" y1="300" x2="150" y2="60" />
              <line className="connection-line" x1="300" y1="300" x2="460" y2="45" />
              <line className="connection-line" x1="300" y1="300" x2="30" y2="195" />
              <line className="connection-line" x1="300" y1="300" x2="550" y2="160" />
              <line className="connection-line" x1="300" y1="300" x2="70" y2="420" />
              <line className="connection-line" x1="300" y1="300" x2="560" y2="435" />
              <line className="connection-line" x1="300" y1="300" x2="180" y2="545" />
              <line className="connection-line" x1="300" y1="300" x2="470" y2="555" />
            </svg>
          </div>

          {/* Central Wayo hub */}
          <div className="discovery-hub">
            <img
              className="discovery-hub-photo"
              src="/assets/img/memoji/memoji-wayo.webp"
              alt="Wayo"
            />
            <div className="discovery-hub-label">wayo</div>
          </div>

          {/* Coach avatars */}
          {coaches.map((coach, index) => (
            <div key={index} className={`coach-avatar ${coach.position}`}>
              <div className="coach-avatar-ring">
                <div className={`coach-avatar-img ${coach.gradientClass}`}>
                  <img
                    className="coach-avatar-photo"
                    src={coach.image}
                    alt={coach.name}
                  />
                </div>
              </div>
              <div className="coach-avatar-status"></div>
              <div className="coach-avatar-tooltip">
                <div className="tooltip-name">{coach.name}</div>
                <div className="tooltip-specialty">{coach.specialty}</div>
                <div className="tooltip-content">
                  <div className="tooltip-stat">
                    <strong>{coach.workouts}</strong> entrenos
                  </div>
                  <div className="tooltip-stat">
                    <strong>{coach.guides}</strong> guías
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
